import { render, staticRenderFns } from "./SubSchema.vue?vue&type=template&id=52e39c42&"
import script from "./SubSchema.vue?vue&type=script&lang=js&"
export * from "./SubSchema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports